/* NRG-5 緊急口糧銷售頁 v1.0.0
   只處理本 section 內的互動；不讀寫價格、variant、庫存，也不送出任何購物車表單。 */
(function () {
  'use strict';

  var root = document.querySelector('[data-nrg5-root]');
  if (!root) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('nrg5-js');

  /* ---------- 捲動進場 ---------- */
  function initReveal() {
    var items = root.querySelectorAll('[data-reveal]');
    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Tagline 逐詞點亮 ---------- */
  function segmentText(text) {
    try {
      if (window.Intl && Intl.Segmenter) {
        var seg = new Intl.Segmenter('zh-TW', { granularity: 'word' });
        return Array.from(seg.segment(text), function (s) { return s.segment; });
      }
    } catch (err) {
      /* 不支援 zh-TW 分詞的環境改用逐字元 */
    }
    return Array.from(text);
  }

  function initTagline() {
    var section = root.querySelector('[data-nrg5="tagline"]');
    var textEl = section && section.querySelector('[data-tagline]');
    if (!textEl) return;

    var index = 0;
    Array.from(textEl.childNodes).forEach(function (node) {
      if (node.nodeType !== Node.TEXT_NODE) return;
      var frag = document.createDocumentFragment();
      segmentText(node.textContent).forEach(function (part) {
        if (!part.trim()) {
          frag.appendChild(document.createTextNode(part));
          return;
        }
        var span = document.createElement('span');
        span.className = 'nrg5-lp__word';
        span.style.setProperty('--i', String(index));
        span.textContent = part;
        index += 1;
        frag.appendChild(span);
      });
      node.replaceWith(frag);
    });

    if (reduceMotion || !('IntersectionObserver' in window)) {
      section.classList.add('is-lit');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      section.classList.add('is-lit');
      io.disconnect();
    }, { threshold: 0.6 });
    io.observe(section);
  }

  /* ---------- 情境分頁 ---------- */
  function initTabs() {
    var list = root.querySelector('[data-tabs]');
    if (!list) return;
    var tabs = Array.from(list.querySelectorAll('[role="tab"]'));

    function select(tab, moveFocus) {
      tabs.forEach(function (t) {
        var active = t === tab;
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.tabIndex = active ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !active;
      });
      if (moveFocus) tab.focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') next = tabs[0];
        if (e.key === 'End') next = tabs[tabs.length - 1];
        if (!next) return;
        e.preventDefault();
        select(next, true);
      });
    });
  }

  /* ---------- 備糧計算器 ---------- */
  function initCalc() {
    var calc = root.querySelector('[data-calc]');
    if (!calc) return;
    var limits = { people: { min: 1, max: 20 }, days: { min: 1, max: 30 } };
    var state = { people: 2, days: 3 };
    var result = calc.querySelector('[data-result]');

    function render() {
      Object.keys(state).forEach(function (key) {
        var out = calc.querySelector('[data-val="' + key + '"]');
        if (out) out.textContent = String(state[key]);
        calc.querySelectorAll('[data-step="' + key + '"]').forEach(function (btn) {
          var dir = Number(btn.getAttribute('data-dir'));
          btn.disabled = dir < 0 ? state[key] <= limits[key].min : state[key] >= limits[key].max;
        });
      });
      if (result) result.textContent = String(state.people * state.days);
    }

    calc.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-step]');
      if (!btn || btn.disabled) return;
      var key = btn.getAttribute('data-step');
      if (!limits[key]) return;
      var next = state[key] + Number(btn.getAttribute('data-dir'));
      var patch = {};
      patch[key] = Math.min(limits[key].max, Math.max(limits[key].min, next));
      state = Object.assign({}, state, patch);
      render();
    });

    render();
  }

  /* ---------- 文件放大 ---------- */
  function initDialog() {
    var dialog = root.querySelector('[data-dialog]');
    if (!dialog) return;
    var img = dialog.querySelector('[data-dialog-img]');
    var errorEl = dialog.querySelector('[data-dialog-error]');
    var body = dialog.querySelector('.nrg5-lp__dialog-body');
    var lastTrigger = null;

    function close() {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    }

    img.addEventListener('load', function () {
      body.classList.remove('is-loading');
      img.hidden = false;
    });
    img.addEventListener('error', function () {
      body.classList.remove('is-loading');
      img.hidden = true;
      errorEl.hidden = false;
    });

    root.querySelectorAll('[data-zoom]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        lastTrigger = btn;
        errorEl.hidden = true;
        img.hidden = true;
        body.classList.add('is-loading');
        img.alt = btn.getAttribute('data-zoom-alt') || '';
        img.src = btn.getAttribute('data-zoom');
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      });
    });

    dialog.querySelector('[data-dialog-close]').addEventListener('click', close);
    dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
    dialog.addEventListener('close', function () {
      if (lastTrigger) lastTrigger.focus();
    });
  }

  /* ---------- 回到商品選項（只連到 LP 前方既有的原生購買表單） ---------- */
  function initBackToBuy() {
    var links = root.querySelectorAll('[data-back-to-buy]');
    if (!links.length) return;

    var forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
    var form = forms.find(function (f) {
      var precedes = root.compareDocumentPosition(f) & Node.DOCUMENT_POSITION_PRECEDING;
      return precedes && f.querySelector('[type="submit"], button[name="add"]');
    });
    if (!form) return; /* 找不到真實購買區：維持隱藏 */

    var target = form.closest('[id^="ProductInfo-"]') || form;
    if (!target.id) target.id = 'nrg5-buy-target';
    var submit = form.querySelector('[type="submit"], button[name="add"]');

    links.forEach(function (link) {
      link.setAttribute('href', '#' + target.id);
      link.hidden = false;
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var header = document.querySelector('.shopify-section-header-sticky');
        var offset = header ? header.offsetHeight + 16 : 16;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });
        if (submit) submit.focus({ preventScroll: true });
      });
    });
  }

  // 示範影片：捲到畫面內才自動播放（靜音），捲走就暫停；避免一進頁就下載整支影片
  function initDemoVideo() {
    var videos = root.querySelectorAll('.nrg5-lp__video video');
    if (!videos.length) return;
    videos.forEach(function (v) {
      v.muted = true;
      v.setAttribute('playsinline', '');
    });
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.5 });
    videos.forEach(function (v) { io.observe(v); });
  }

  /* YouTube 使用獨立路徑，避免影響既有 Shopify 原生影片。 */
  const YOUTUBE_API_URL = 'https://www.youtube.com/iframe_api';
  const YOUTUBE_API_TIMEOUT_MS = 12000;
  const YOUTUBE_MIN_VISIBILITY = 0.5;
  const YOUTUBE_VISIBILITY_THRESHOLDS = [0, 0.5, 0.51, 1];
  let youtubeApiPromise = null;

  function loadYoutubeApi() {
    if (window.YT && typeof window.YT.Player === 'function') return Promise.resolve(window.YT);
    if (youtubeApiPromise) return youtubeApiPromise;
    youtubeApiPromise = new Promise(function (resolve, reject) {
      const previousReady = window.onYouTubeIframeAPIReady;
      const timeout = window.setTimeout(function () { reject(new Error('YouTube API 載入逾時')); }, YOUTUBE_API_TIMEOUT_MS);
      function ready() {
        if (!window.YT || typeof window.YT.Player !== 'function') return;
        window.clearTimeout(timeout);
        resolve(window.YT);
      }
      window.onYouTubeIframeAPIReady = function () {
        if (typeof previousReady === 'function') {
          try { previousReady(); } catch (error) { /* 其他元件的錯誤不應阻止本播放器初始化。 */ }
        }
        ready();
      };
      const existing = document.querySelector('script[src="' + YOUTUBE_API_URL + '"]');
      if (!existing) {
        const script = document.createElement('script');
        script.src = YOUTUBE_API_URL;
        script.async = true;
        script.addEventListener('error', function () {
          window.clearTimeout(timeout);
          reject(new Error('YouTube API 無法載入'));
        }, { once: true });
        document.head.appendChild(script);
      }
      ready();
    });
    return youtubeApiPromise;
  }

  class YoutubePlayback {
    constructor(frame) {
      this.frame = frame;
      this.notice = frame.closest('figure').querySelector('[data-youtube-notice]');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.state = { player: null, ready: false, visible: false, loading: false, manualPaused: false, commandedPause: false, blocked: false, ended: false, volumeInitialized: false };
      this.motion.addEventListener('change', () => this.updateVisible(this.state.visible));
      document.addEventListener('visibilitychange', () => this.updateVisible(this.state.visible));
    }

    updateState(patch) {
      this.state = Object.assign({}, this.state, patch);
    }

    showState(value) {
      this.frame.dataset.youtubeState = value;
      if (this.notice) this.notice.hidden = value !== 'blocked' && value !== 'error';
    }

    canAutoplay() {
      return this.state.visible && !document.hidden && !this.motion.matches && !this.state.manualPaused && !this.state.blocked && !this.state.ended;
    }

    updateVisible(visible) {
      this.updateState({ visible: visible });
      if (visible && !document.hidden && !this.state.loading && !this.state.ready) this.load();
      this.sync();
    }

    load() {
      this.updateState({ loading: true });
      this.showState('loading');
      loadYoutubeApi().then((api) => new api.Player(this.frame, {
        events: {
          onReady: (event) => this.onReady(event),
          onStateChange: (event) => this.onPlayerState(event),
          onAutoplayBlocked: () => this.fail('blocked'),
          onError: (event) => this.fail('error', event.data)
        }
      })).catch(() => this.fail('error'));
    }

    onReady(event) {
      const player = event.target;
      const status = player.getPlayerState();
      const playing = status === window.YT.PlayerState.PLAYING || status === window.YT.PlayerState.BUFFERING;
      const paused = status === window.YT.PlayerState.PAUSED;
      const ended = status === window.YT.PlayerState.ENDED;
      this.updateState({ player: player, ready: true, manualPaused: paused, ended: ended, volumeInitialized: playing || paused || ended });
      // API 尚在載入時，訪客可能已手動操作 iframe；此時保留音量與暫停決定。
      this.showState(playing ? 'playing' : paused ? 'paused' : ended ? 'ended' : 'ready');
      this.sync();
    }

    onPlayerState(event) {
      if (event.data === window.YT.PlayerState.PLAYING) {
        this.updateState({ manualPaused: false, commandedPause: false, ended: false, volumeInitialized: true });
        this.showState('playing');
        if (!this.state.visible || document.hidden) this.sync();
      } else if (event.data === window.YT.PlayerState.PAUSED) {
        const userPaused = !this.state.commandedPause && this.state.visible && !document.hidden;
        this.updateState({ manualPaused: this.state.manualPaused || userPaused, commandedPause: false });
        this.showState('paused');
      } else if (event.data === window.YT.PlayerState.ENDED) {
        this.updateState({ ended: true });
        this.showState('ended');
      }
    }

    sync() {
      if (!this.state.ready) return;
      const player = this.state.player;
      const status = player.getPlayerState();
      const active = status === window.YT.PlayerState.PLAYING || status === window.YT.PlayerState.BUFFERING;
      if (this.canAutoplay() && !active) {
        if (!this.state.volumeInitialized) {
          player.mute();
          this.updateState({ volumeInitialized: true });
        }
        player.playVideo();
      } else if ((!this.state.visible || document.hidden) && active) {
        this.updateState({ commandedPause: true });
        player.pauseVideo();
      }
    }

    fail(value, code) {
      this.updateState({ blocked: true });
      if (code !== undefined) this.frame.dataset.youtubeError = String(code);
      this.showState(value);
    }
  }

  function initYoutubeVideo() {
    const frame = root.querySelector('iframe[data-lp-youtube]');
    if (!frame || !/^[A-Za-z0-9_-]{11}$/.test(frame.dataset.youtubeId || '')) return;
    const source = new URL(frame.dataset.youtubeSrc);
    if (/^https?:$/.test(window.location.protocol)) source.searchParams.set('origin', window.location.origin);
    frame.src = source.href;
    frame.dataset.youtubeState = 'manual';
    if (!('IntersectionObserver' in window)) return;
    const playback = new YoutubePlayback(frame);
    const observer = new IntersectionObserver(function (entries) {
      const entry = entries[0];
      playback.updateVisible(entry.isIntersecting && entry.intersectionRatio > YOUTUBE_MIN_VISIBILITY);
    }, { threshold: YOUTUBE_VISIBILITY_THRESHOLDS });
    observer.observe(frame);
  }

  initReveal();
  initTagline();
  initTabs();
  initCalc();
  initDialog();
  initBackToBuy();
  initDemoVideo();
  initYoutubeVideo();
})();
